import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mb-0" }, " Assegna l'ordine ", -1)
const _hoisted_2 = { class: "p-d-flex" }
const _hoisted_3 = { class: "p-field-radiobutton" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "taker_radio" }, "Taker", -1)
const _hoisted_5 = { class: "p-field-radiobutton p-ml-3" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "supplier_radio" }, "Fornitore", -1)
const _hoisted_7 = {
  key: 0,
  class: "p-mt-3"
}
const _hoisted_8 = { class: "p-inputgroup" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1)
const _hoisted_10 = {
  key: 0,
  class: "p-mt-3"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Fornitore selezionato ")
const _hoisted_12 = { class: "p-grid" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-5 p-sm-3 p-md-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome: ")
], -1)
const _hoisted_14 = { class: "p-col-7 p-sm-5 p-md-6" }
const _hoisted_15 = { class: "p-grid" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-5 p-sm-3 p-md-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Cognome: ")
], -1)
const _hoisted_17 = { class: "p-col-7 p-sm-5 p-md-6" }
const _hoisted_18 = { class: "p-fluid p-mt-3" }
const _hoisted_19 = {
  key: 1,
  class: "p-mt-3"
}
const _hoisted_20 = { class: "p-inputgroup" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1)
const _hoisted_22 = {
  key: 0,
  class: "p-mt-3"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Taker selezionato ")
const _hoisted_24 = { class: "p-grid" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-5 p-sm-3 p-md-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nome: ")
], -1)
const _hoisted_26 = { class: "p-col-7 p-sm-5 p-md-6" }
const _hoisted_27 = { class: "p-grid" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-5 p-sm-3 p-md-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Cognome: ")
], -1)
const _hoisted_29 = { class: "p-col-7 p-sm-5 p-md-6" }
const _hoisted_30 = { class: "p-fluid p-mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createBlock(_component_PDialog, {
    style: { width: '450px' },
    modal: true,
    class: "p-fluid",
    onHide: _ctx.onHide,
    draggable: true,
    keepInViewPort: true,
    minX: 0,
    minY: 0
  }, {
    header: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_Toast, { group: "this_dialog" })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Annulla",
        icon: "pi pi-times",
        class: "p-button-secondary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update:visible', false)))
      }),
      _createVNode(_component_Button, {
        label: "Conferma",
        icon: "pi pi-check",
        onClick: _ctx.onConfirm,
        disabled: !_ctx.entityType && !_ctx.selected
      }, null, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_RadioButton, {
              id: "taker_radio",
              name: "entityType",
              value: _ctx.takerValue,
              modelValue: _ctx.entityType,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => (_ctx.entityType = $event)),
                _ctx.onTypeChange
              ]
            }, null, 8, ["value", "modelValue", "onUpdate:modelValue"]),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_RadioButton, {
              id: "supplier_radio",
              name: "entityType",
              value: _ctx.supplierValue,
              modelValue: _ctx.entityType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.entityType = $event))
            }, null, 8, ["value", "modelValue"]),
            _hoisted_6
          ])
        ]),
        (_ctx.entityType === _ctx.supplierValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_AutoComplete, {
                  completeOnFocus: "",
                  modelValue: _ctx.searchBox,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchBox = $event)),
                  suggestions: _ctx.suggestions,
                  field: _ctx.supplierLabel,
                  minLength: 2,
                  placeholder: "Cerca fornitore per nome ",
                  onItemSelect: _ctx.onSelect,
                  onComplete: _ctx.search
                }, null, 8, ["modelValue", "suggestions", "field", "onItemSelect", "onComplete"])
              ]),
              (_ctx.selected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_Card, { class: "p-shadow-2" }, {
                      title: _withCtx(() => [
                        _hoisted_11
                      ]),
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.selected.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.selected.surname), 1)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_FloatLabel, {
                            label: _ctx.$t('entity.business_note')
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Textarea, {
                                autoResize: true,
                                modelValue: _ctx.selected.business_note,
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.entityType === _ctx.takerValue)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_AutoComplete, {
                    completeOnFocus: "",
                    modelValue: _ctx.searchBox,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchBox = $event)),
                    suggestions: _ctx.suggestions,
                    field: _ctx.takerLabel,
                    minLength: 2,
                    placeholder: "Cerca taker per nome ",
                    onItemSelect: _ctx.onSelect,
                    onComplete: _ctx.searchTaker
                  }, null, 8, ["modelValue", "suggestions", "field", "onItemSelect", "onComplete"])
                ]),
                (_ctx.selected)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_component_Card, { class: "p-shadow-2" }, {
                        title: _withCtx(() => [
                          _hoisted_23
                        ]),
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.selected.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.selected.surname), 1)
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_FloatLabel, {
                              label: _ctx.$t('entity.business_note')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Textarea, {
                                  autoResize: true,
                                  modelValue: _ctx.selected.business_note,
                                  readonly: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
      ], 32)
    ]),
    _: 1
  }, 8, ["onHide"]))
}